import { useEffect } from 'react'
import { MAIN_APP_URL, STORAGE_KEYS } from 'src/constants'

const adminOrigin = (() => {
  try {
    return new URL(MAIN_APP_URL).origin
  } catch {
    return null
  }
})()

export default function AuthPage() {
  useEffect(() => {
    function messageHandler(e: MessageEvent) {
      // Only the admin app may hand us a session token
      if (!adminOrigin || e.origin !== adminOrigin) return

      if (e.data && typeof e.data === 'object' && typeof e.data.token === 'string') {
        localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, e.data.token)
      }
    }

    addEventListener('message', messageHandler)

    return () => removeEventListener('message', messageHandler)
  }, [])

  return null
}
